import { READING_ACTION_TYPES, POST_READING_ACTION_TYPES, READING_MODE_ACTION_TYPES } from '../actions/action_types';
import { isAnsweredCorrectlyOnFirstTry } from '../../services/activities';

export const initialState = {
  questions: [],
  remainingQuestions: [],
  pendingRemainingQuestions: [],
  correctlyAnswered: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case READING_ACTION_TYPES.SET_BOOK_STATE:
      return {
        ...state,
        correctlyAnswered: payload.postReadingAnswers
          .filter(isAnsweredCorrectlyOnFirstTry)
          .map(({ questionId }) => questionId),
      };
    case POST_READING_ACTION_TYPES.SET_ALL_QUESTIONS:
      return { ...state, questions: payload };
    case POST_READING_ACTION_TYPES.SET_REMAINING_QUESTIONS:
      return { ...state, remainingQuestions: payload };
    case READING_MODE_ACTION_TYPES.RETURN_TO_CHALLENGE:
    case READING_MODE_ACTION_TYPES.RETURN_TO_UNANSWERED_QUESTIONS:
      if (state.correctlyAnswered.length > 0) {
        return {
          ...state,
          remainingQuestions: state.pendingRemainingQuestions,
          pendingRemainingQuestions: [],
        };
      }
      return state;
    case POST_READING_ACTION_TYPES.ANSWER_CORRECT: {
      const correctlyAnswered = [...state.correctlyAnswered];
      const pendingRemainingQuestions = [];
      // add latest Q to correctly answered PR questions
      if (!correctlyAnswered.includes(payload.questionId)) {
        correctlyAnswered.push(payload.questionId);
      }

      for (let i = 0; i < state.remainingQuestions.length; i++) {
        if (state.remainingQuestions[i].questionId !== payload.questionId) {
          pendingRemainingQuestions.push(state.remainingQuestions[i]);
        }
      }
      return {
        ...state,
        correctlyAnswered,
        pendingRemainingQuestions,
      };
    }

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    default:
      return state;
  }
};
